module.exports = __webpack_public_path__ + "static/conway-law-6d642431694e4ca338e4fd611e6cf37b.png";